export const CREATE_APPLICANT_DATA = "CREATE_APPLICANT_DATA";
export const RETRIEVE_LANDINGPAGE = "RETRIEVE_LANDINGPAGE";
export const UPDATE_TUTORIAL = "UPDATE_TUTORIAL";
export const DELETE_TUTORIAL = "DELETE_TUTORIAL";
export const DELETE_ALL_TUTORIALS = "DELETE_ALL_TUTORIALS";
